import IconComponent from "app/shared-components/IconComponent";
import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "../../utilities/AgGridTable";
import ListPageHeader from "../../utilities/ListPageHeader";
import moment from "moment";


const TrainingCourseList = () => {

  const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.trainersList}`;

  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState();
  const [gridApi, setGridApi] = useState(null);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [deleteDisable, setDeleteDisable] = useState(true);
  const [error, setError] = useState("")
  const perPage = 10;
  const gridRef = useRef();
  const navigate = useNavigate();
  const [columnDefs, setColumnDefs] = useState([
    { field: 'trainingCourseId', enableRowGroup: true },
    { field: 'trainingCourse', enableRowGroup: true, headerName:"Trainer Name" },
    { field: 'trainingTopics', enableRowGroup: true },
  ]);

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
      let employees = list.data?._embedded?.employees;
      employees = employees.map((employee) => {
        const empFullName = `${employee.empFirstName} ${employee.empMiddleName} ${employee.empLastName}`;
        employee.employeeName = empFullName;
        return employee;
    });
      setRowData(employees);
    } catch (error) {
      setError(error.message);
    }
  }

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);

  const handlePurge = (e) => {
    selectedRows.map(async (row) => {
      try {
        await OAuthService.deleteData(url, row.employeeId);
        setSuccessMsg("Data deleted Successfully")
        setSnackState(true);
        loadData();
      } catch (error) {
        console.log("eror", error);
        setError(error.message);
      }
    })
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: 'Employees.xlsx',
      sheetName: 'Employees'
    }
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  }

  const onRowDoubleClicked = (params) => {
    navigate('/editTrainingCourse/' + selectedRows[0]?.employeeId)
  }

  useEffect(() => {
    if (selectedRows.length > 0) {
      setDeleteDisable(false)
    } else {
      setDeleteDisable(true)
    }
  }, [selectedRows])

  return (
    <>
      <ListPageHeader
        componentName="TrainingCourse"
        // onBtExport={onBtExport}
        handlePurge={handlePurge}
        addPageLink="/addTrainingCourse"
        pageName="Training Course"
        // error={error}
        deleteDisable={deleteDisable}
        successMsg={successMsg}
        gridRef={gridRef}
        snackState={snackState}
      />
      <div className="h-full">
        <AgGridTable
          columnDefs={columnDefs}
          rowData={rowData}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
          gridRef={gridRef}
          paginationPageSize={perPage}
          cacheBlockSize={perPage}
          saveGridStateName={'trainingCourse'}
        />
      </div>
    </>
  )
}

export default TrainingCourseList;